import { render, staticRenderFns } from "./ModalProductTransfer.vue?vue&type=template&id=7370572e&"
import script from "./ModalProductTransfer.vue?vue&type=script&lang=js&"
export * from "./ModalProductTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports